import { client } from '../http';

export default {
  async fetchApplicationState() {
    const response = await client.get('/api/application-state');
    return response.data;
  },
};
